<template lang="pug">
  .profile-page__main
    .profile-page__header
      .profile-page__title
        h1.title {{title}}
    .profile-page__body
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Общая информация
        .profile-section__body
          .form
            .form__elem
              .form-elem.form-elem_horizontal(
                :class="{'form-elem_error':fieldsErrors.lastName.value}"
              )
                .form-elem__title Фамилия
                .form-elem__body
                  input.input.input_full(
                  maxlength="128"
                  v-model="fields.lastName"
                  @input="resetError('lastName')"
                  )
            .form__elem
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error':fieldsErrors.firstName.value}"
              )
                .form-elem__title Имя
                .form-elem__body
                  input.input.input_full(
                  maxlength="128"
                  v-model="fields.firstName"
                  @input="resetError('firstName')"
                  )
            .form__elem
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error':fieldsErrors.fathersName.value}"
              )
                .form-elem__title Отчество
                .form-elem__body
                  input.input.input_full(
                  maxlength="128"
                  v-model="fields.fathersName"
                  @input="resetError('fathersName')"
                  )
            .form__elem
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error':emailError}"
              )
                .form-elem__title Электронная почта
                .form-elem__body
                  input.input.input_full(
                  maxlength="50"
                  v-model="fields.email"
                  @input="resetError('email')"
                  )
            .form__elem
              .form-elem.form-elem_horizontal(
              :class="{'form-elem_error':fieldsErrors.vdc.value}"
              )
                .form-elem__title Центр Распределения Путевок
                .form-elem__body
                  simple-select-form(
                  :list-data="vdcList"
                  :default-value="fields.vdc"
                  @onChangeDefaultValue="changeVdcValue"
                  type="vdc"
                  :specificChoice="true"
                  @change="resetError('vdc')"
                  )
      section.form__elem.form__elem--align-right.form__elem_full
        .form-elem
          .form-elem__main
            button.button.button_paint-main(
            @click="onSaveAccount"
            )
              .button__text {{ buttonText }}
          .form-elem__error(
          v-if="currentErrorMessage.length > 0"
          ) {{ currentErrorMessage }}
</template>

<script>
import {mapActions} from "vuex";
import SimpleSelectForm from "../../../../../components/simpleSelectForm/SimpleSelectForm";
import {RoleEnums} from "../../../../../const/index.js";

export default {
  name: "AdminAccountEditor",
  components: {SimpleSelectForm},
  data() {
    return {
      vdcList: [],
      fields: {
        firstName: "",
        lastName: "",
        fathersName: "",
        email: "",
        vdc: {
          value: null,
          text: "Выберите из списка"
        }
      },
      fieldsErrors: {
        firstName: {
          value: false,
          message: "Введите имя"
        },
        lastName: {
          value: false,
          message: "Введите фамилию"
        },
        fathersName: {
          value: false,
          message: "Введите отчество"
        },
        emptyEmail: {
          value: false,
          message: "Введите email"
        },
        incorrectEmail: {
          value: false,
          message: "Неправильный формат email"
        },
        vdc: {
          value: false,
          message: "Выберите центр распределения"
        }
      },
      currentErrorMessage: ""
    };
  },
  computed: {
    pageOptionStaffCamp() {
      const arr = this.$route.path.split("/");
      return arr[arr.length - 2] === "staff-camp";
    },
    emailError() {
      if (this.fieldsErrors.emptyEmail.value || this.fieldsErrors.incorrectEmail.value) {
        return true;
      }
      return false;
    },
    role() {
      if (this.pageOptionStaffCamp) {
        return RoleEnums.DIRECTOR;
      }
      return RoleEnums.CAMP_GROUP_ADMIN;
    },
    mode() {
      if (this.$route.params.id === "create") {
        return "create";
      }
      return "edit";
    },
    staffAccountId() {
      if (this.$route.params.id) {
        return this.$route.params.id;
      }
      return null;
    },
    title() {
      let a = "Создание";
      let b = "учетной записи администратора центра распределения путевок";
      if (this.mode === "edit") {
        a = "Редактирование";
      }
      if (this.pageOptionStaffCamp) {
        b = "учетной записи директора";
      }
      return `${a} ${b}`;
    },
    buttonText() {
      if (this.mode === "edit") {
        return "Сохранить";
      }
      return "Создать учетную запись";
    }
  },
  methods: {
    ...mapActions(["getCampgroups", "createStaffAccount", "getStaffAccount", "updateStaffAccount"]),
    changeVdcValue(data, type) {
      this.fields[type] = data;
      this.resetError(type);
    },
    resetError(field) {
      switch (field) {
        case "email":
          this.fieldsErrors.emptyEmail.value = false;
          this.fieldsErrors.incorrectEmail.value = false;
          break;
        default:
          this.fieldsErrors[field].value = false;
      }
      this.currentErrorMessage = "";
    },
    validation() {
      const errors = [];
      const emailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const emailField = this.fields.email;
      const simpleFields = [
        "lastName",
        "firstName",
        "fathersName"
      ];
      simpleFields.forEach(item => {
        if (this.fields[item].length === 0) {
          errors.push(item);
        }
      });
      if (emailField.length === 0) {
        errors.push("emptyEmail");
      }
      if (!emailReg.test(emailField)) {
        errors.push("incorrectEmail");
      }
      if (this.fields.vdc.value === null) {
        errors.push("vdc");
      }

      if (errors.length > 0) {
        errors.forEach((item) => {
          this.fieldsErrors[item].value = true;
        });
        this.currentErrorMessage = this.fieldsErrors[errors[0]].message;
        return false;
      }
      return true;
    },
    onSaveAccount() {
      if (!this.validation()) {
        return;
      }
      const data = {
        first_name: this.fields.firstName,
        last_name: this.fields.lastName,
        fathers_name: this.fields.fathersName,
        email: this.fields.email,
        role: this.role,
        campgroup: this.fields.vdc.value
      };

      if (this.mode === "edit") {
        this.updateStaffAccount({
          id: this.staffAccountId,
          data: data
        }).then((res) => {
          if (res.status === 200) {
            this.campData = res.data;
            this.$root.$emit("onShowNotificationModal", {
              text: "Учетная запись обновлена"
            });
          } else {
            this.$root.$emit("onShowNotificationModal", {
              text: `${res.status} ошибка`
            });
          }
        });
      } else {
        this.createStaffAccount(data).then(res => {
          if (res.status === 201) {
            this.$router.push({name: "AdminAccountsRegistry"});
            this.$root.$emit("onShowNotificationModal", {
              text: "Учетная запись создана"
            });
          } else {
            if (res.data.email) {
              this.$root.$emit("onShowErrorModal", {
                text: "На данную почту уже создана учетная запись. Используйте другой email для регистрации учетной записи."
              });
              return;
            }
            this.$root.$emit("onShowErrorModal", {
              text: `${res.status} ошибка`
            });
          }
        });
      }
    },
    setFields(accountData) {
      this.fields.firstName = accountData.first_name;
      this.fields.lastName = accountData.last_name;
      this.fields.fathersName = accountData.fathers_name;
      this.fields.email = accountData.email;
      this.fields.vdc = this.vdcList.find((item) => {
        return item.value === accountData.campgroup.id;
      });
    }
  },
  created() {
    this.$root.$emit("on-show-preloader");
  },
  mounted() {
    const _this = this;
    const getCampgroupsPromise = new Promise((resolve, reject) => {
      _this.getCampgroups().then(res => {
        _this.vdcList = res.map(item => {
          return {
            value: item.id,
            text: item.name
          };
        });
        resolve();
      });
    });
    getCampgroupsPromise.then(() => {
      if (this.mode === "edit") {
        this.getStaffAccount(this.staffAccountId).then((res) => {
          this.setFields(res);
          this.$root.$emit("on-hide-preloader");
        });
      } else {
        this.$root.$emit("on-hide-preloader");
      }
    });
  }
};
</script>
